import { useExamCenter } from '@exam-center/admin-exam-center-details';
import { AdminExamCenterMemberDetailsModal } from '@exam-center/exam-center-member-details';
import { useAdminGetExamCenterMembersByExamCenterCodeQuery } from '@exam-center/graphql';
import { type GridCellParams } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useMemo, useState } from 'react';

import { BaseExamCenterMemberDataGrid } from '../../components';
import { ExamCenterMemberListNoRowsOverlay } from '../exam-center-member-list-no-rows-overlay';

import { columns, type ExamCenterMemberListItem } from './columns';
import { mapExamCenterMemberData } from './mapper';

export default function ExamCenterMemberList() {
  const { examCenter } = useExamCenter();
  const { code: examCenterCode } = examCenter;

  const [isMemberDetailsModalOpen, memberDetailsModalHandlers] = useDisclosure();
  const { open: openMemberDetailsModal, close: closeMemberDetailsModal } =
    memberDetailsModalHandlers;

  const [examCenterMemberId, setExamCenterMemberId] = useState('');

  const { data: membersData, loading: isLoading } =
    useAdminGetExamCenterMembersByExamCenterCodeQuery({
      variables: {
        getExamCenterMembersByExamCenterCodeInput: {
          examCenterCode: examCenterCode,
        },
      },
    });

  const members = useMemo(() => {
    return (
      membersData?.ecAdminGetExamCenterMembersByExamCenterCode.examCenterMembers.map(
        (member, index) => mapExamCenterMemberData(member, index + 1),
      ) ?? []
    );
  }, [membersData]);

  const handleClickMemberRow = (params: GridCellParams<ExamCenterMemberListItem>) => {
    setExamCenterMemberId(params.row.id);
    openMemberDetailsModal();
  };

  return (
    <>
      <BaseExamCenterMemberDataGrid
        columns={columns}
        rows={members}
        loading={isLoading}
        onCellClick={handleClickMemberRow}
        slots={{
          noRowsOverlay: ExamCenterMemberListNoRowsOverlay,
        }}
      />
      <AdminExamCenterMemberDetailsModal
        open={isMemberDetailsModalOpen}
        onClose={closeMemberDetailsModal}
        examCenterMemberId={examCenterMemberId}
      />
    </>
  );
}
